import './style.scss';

export function home_hero_block() {
    const block = document.querySelector('.home_hero_block');
    if (!block) return;

}
